import React, { useEffect, useRef, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import Logo from './Logo';
import { SITE } from '../mock';

const STORAGE_KEY = 'asianrisk_age_ok';

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const dialogRef = useRef(null);
  const firstBtn = useRef(null);
  const prevFocus = useRef(null);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'true') setOpen(true);
    } catch (err) {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    prevFocus.current = document.activeElement;
    document.body.style.overflow = 'hidden';
    firstBtn.current?.focus();
    const onKey = (e) => {
      if (e.key !== 'Tab' || !dialogRef.current) return;
      const els = dialogRef.current.querySelectorAll('button, a[href]');
      const first = els[0];
      const last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      prevFocus.current?.focus?.();
    };
  }, [open]);

  const confirm = () => {
    try { localStorage.setItem(STORAGE_KEY, 'true'); } catch (err) { /* storage unavailable */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{ background: 'rgba(3,5,10,0.88)' }}>
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="agegate-title" aria-describedby="agegate-desc" data-testid="age-gate"
        className="ar-panel max-w-md w-full p-8 text-center relative" style={{ borderColor: 'rgba(0,217,255,0.35)' }}>
        <div className="flex justify-center mb-5"><Logo size={72} /></div>
        <div className="inline-flex items-center gap-2 mb-4" aria-hidden="true">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full font-display font-bold text-sm" style={{ border: '2px solid #ff5c5c', color: '#ff7b7b' }}>18+</span>
          <ShieldAlert size={22} className="text-cyan" />
        </div>
        <h2 id="agegate-title" className="font-display font-bold text-2xl mb-3">Are You Of Legal Age?</h2>
        <p id="agegate-desc" className="text-sm text-muted leading-relaxed mb-7">
          You must be of legal gambling age in your jurisdiction (18+/21+) to enter.
          AsianRisk is for entertainment only. Please gamble responsibly.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button ref={firstBtn} type="button" onClick={confirm} data-testid="age-gate-confirm-btn" className="btn-cyan w-full">I AM 18 OR OLDER</button>
          <button type="button" onClick={() => { window.location.href = 'https://www.google.com'; }} data-testid="age-gate-exit-btn" className="btn-ghost w-full">EXIT</button>
        </div>
        <p className="text-[11px] text-muted mt-5">
          By entering you agree you are using code {SITE.code} responsibly. Need help? Visit{' '}
          <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer" className="text-cyan hover:underline">BeGambleAware.org</a>.
        </p>
      </div>
    </div>
  );
}
